import { functions } from '../../modules/functions';
import { Offset } from '../../modules/offset';

export module ScrollActionModule {

  interface status {
    targetElements: HTMLCollectionOf<Element>
  }

  export class Service {
    private static $status: status;

    constructor(language?: string) {
      document.addEventListener('readCompleteAction', () => {
        let $targetElements = document.getElementsByClassName('js__scroll js__scroll--bodyAction');
        if ($targetElements.length) {
          Service.$status = {
            targetElements: $targetElements
          };
          Service.ScrollEvent();
        }
      });
    }

    /**
     * イベント設定
     */
    public static ScrollEvent() {
      functions.addEventListenerMultiType(document, 'scroll touchmove', () => { Service.ScrollAction(); }, true);
    }

    /**
     * イベント実行
     */
    public static ScrollAction() {
      if (Service.$status.targetElements.length) {
        let $windowHeight = functions.getWindowHeight();
        let $scrollTop = functions.getBodyOrScrollingElement().scrollTop + ($windowHeight / 2);
        for (let $key in Service.$status.targetElements) {
          let $self = Service.$status.targetElements[$key];
          let $offsetTop = Offset.getTop($self);
          let $target = $self.getAttribute('data-bodyActionTarget');
          if (!$target) {
            return;
          }

          let $targetElement = document.querySelector<HTMLElement>($target);
          if (!$targetElement) {
            return;
          }

          if ($scrollTop > $offsetTop && $scrollTop > ($offsetTop + 1)) {
            if ('1' !== $targetElement.style.opacity) {
              $targetElement.style.opacity = '1';
            }
          } else if ($scrollTop > $offsetTop) {
            let $difference = $scrollTop - $offsetTop;
            $targetElement.style.opacity = String($difference / 1);
          } else {
            if ('0' !== $targetElement.style.opacity) {
              $targetElement.style.opacity = '0';
            }
          }
        }
      }
    }
  }
}
